module.exports = __webpack_public_path__ + "img/handling-massive-product-db-in-magento.69f768b2.webp";